(function() {

	'use strict';
	angular.module('Services').factory('CarrierZonePostcodesWWTableService', CarrierZonePostcodesWWTableService);
	CarrierZonePostcodesWWTableService.$inject = ['Location', 'TableLiteFactory', '$filter', 'ConfirmationModalFactory', 'toastr', '$timeout'];
	function CarrierZonePostcodesWWTableService(Location, TableLiteFactory, $filter, ConfirmationModalFactory, toastr, $timeout) {
		return function (countries) {
            var tableStructure = {
                config: {
                    noExtract: false,
                    noPagination: false,
                    noHeaders: false,
                    noTopOptions: false,
                    noFooter: false,
                    rowsUnclickable: true,
                    class: 'systemZonesPostcodesWW '
                },
                headers: [{
                    label: 'SELECT ALL',
                    class: 'text-center',
                    width: '75px',
                    viewName: 'checkAll',
                    filter: {
                        type: 'checkbox',
                        viewnName: 'enableDisable'
                    }
                },{
                    label: 'COUNTRY',
                    viewName: 'countryName',
                    filterName: 'country',
                    filter: {
                        type: 'select2',
                        viewName: 'name',
                        filterBy: 'code',
                        placeholder: 'Search',
                        class: 'table-input',
                        items: countries,
                        onSelect: header => {
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function(){
                        sort(this.filterName);
                    }
                },{
                    label: 'STATE',
                    viewName: 'stateName',
                    filterName: 'state',
                    width: '200px',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: header => {
                            sendRequest(evaluateFilter(header));
                        }
                    }
                },{
                    label: 'SUBURB',
                    viewName: 'suburb',
                    filterName: 'name',
                    width: '200px',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: header => {
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function(){
                        sort(this.filterName);
                    }
                },{
                    label: 'POSTCODE',
                    viewName: 'postcode',
                    filterName: 'code',
                    width: '10px',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: header => {
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function(){
                        sort(this.filterName);
                    }
                },{
                    label: 'Status',
                    viewName: 'status',
                    filterName: 'enabled',
                    filter: {
                        type: 'select2',
                        placeholder: 'Select One',
                        items: ['Enabled', 'Disabled'],
                        onSelect: function (header) {
                            let filter = {};
                            if (header.filter.model == 'Enabled') {
                                filter[header.filterName] = true;
                            } else {
                                filter[header.filterName] = false;
                            }
                            sendRequest(filter);
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },{
                    label: 'Actions',
                    viewName: 'action',
                    class: 'text-center',
                    filter: {
                        type: 'button',
                        buttons: [
                            {
                                class: 'btn-primary',
                                label: 'ENABLE SELECTED',
                                onClick: () => {
                                    let selectedData = this.tableData.data.filter((value) => {if(value.isSelected) return value;});
                                    let data = {enabled : false, content: selectedData};
                                    if(selectedData.length !== 0) enableDisablePostcode(data, true);
                                }
                            },
                            {
                                class: 'btn-warning',
                                label: 'DISABLE SELECTED',
                                onClick: () => {
                                    let selectedData = this.tableData.data.filter((value) => {if(value.isSelected) return value;});
                                    let data = {enabled : true, content: selectedData};
                                    if(selectedData.length !== 0) enableDisablePostcode(data, true);
                                }
                            }
                        ]
                    }
                }],
                data: []
            };

            const tableActions = new TableLiteFactory(tableStructure,
                {
                    serviceCallback: Location.locationEnabled,
                    callbackFormat: ['filter','success','error'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    defaultFilters : {
                        size: 20,
                        page: 0,
                        sort: 'country,asc'
                    }
                }
            );
            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;

            function buildTableData(data, pagination) {
                /*** START - Building of Data ***/
                tableActions.initializeTableData(data);
                angular.forEach(data.content, function (row) {
                    row.action = changeButton(row);
                    row.countryName = angular.getObjVal(row, 'country.name');
                    row.stateName = angular.getObjVal(row, 'state.name') ? angular.getObjVal(row, 'state.name') : 'N/A';
					row.postcode = angular.getObjVal(row, 'country') ? row.code : 'N/A';
                    row.suburb = angular.getObjVal(row, 'country') ? row.name : 'N/A';

                    row.status = {
                        type: 'status',
                        status: row.enabled,
                        label: row.enabled ? 'Enabled' : 'Disabled'
                    };
                    tableStructure.data.push(row);
                });
                /*** END - Building of Data ***/
            };

            function enableDisablePostcode(data, batch = false) {
                let enableDisableConfirmation = new ConfirmationModalFactory({},{
                    message: `You are about to ${data.enabled ? 'disable': 'enable'}   ${batch ? 'all the selected postcodes.' : 'this postcode.'} ` ,
                    code: 'Do you wish to continue?'
                });

                enableDisableConfirmation.getInstance().result.then(function(cond){
                    if(cond){
                        let status = data.enabled ? false : true;
                        let cleanedData;

                        if(!batch) {cleanedData = []; cleanedData.push(data.id);} 
                        else { cleanedData = cleanPostcodes(data.content); }

                        Location.Postcode.updateStatus({status: status}, success=> {
                            updateTableData(cleanedData, status);
                        }, error=> {
                            toastr.error(error.message, error.code);
                        }, cleanedData);
                    }
                });
            }

            function cleanPostcodes(data) {
                let newData = [];
                for(let i = 0; i < data.length; i++) {
                    newData.push(data[i].id);
                }
                return newData;
            }

            function updateTableData(data, status) {
                let ids = data;
                for(let i = 0; i < ids.length; i++) {
                    let id = ids[i];
                    for(let x = 0; x < tableStructure.data.length; x++) {
                        if(tableStructure.data[x].id === id) {
                            tableStructure.data[x].enabled = status;
                            tableStructure.data[x].status.status = status;
                            tableStructure.data[x].status.label = status ? 'Enabled' : 'Disabled';
                            tableStructure.data[x].action = changeButton(tableStructure.data[x]);
                        }
                    }
                }
            }

            function changeButton(row) {
                return {
                    type:'button',
                    buttons: [{
                        text:  row.enabled ? 'DISABLE' : 'ENABLE',
                        icon: '',
                        class: row.enabled ? 'btn-danger' : 'btn-success',
                        action: (data) => {
                            enableDisablePostcode(data);
                        }
                    }]
                }
            }

            this.tableData = tableStructure;
        }
	};
})();


// WEBPACK FOOTER //
// ./js/services/tables/CarrierZonePostcodesWWTableService.js